export const TELESCOPES = {
  cassegrain: {
    active: true,
    label: '60cm Cassegrain',
    diameter: 0.6,
    focalLength: 6,
    effectiveAreaCoeff: 1
  },
  nasmyth: {
    active: true,
    label: '1.4m Milankovic',
    diameter: 1.4,
    focalLength: 11.2,
    effectiveAreaCoeff: 1
  }
};

export const CAMERAS = {
  iXon897: {
    active: true,
    label: 'ANDOR iXon 897',
    dc: 0.00030,
    ro: 5.3,
    pxSize: 16e-6,
    qe: {
      '0': 0.97, // peak QE
      '300': 0.12,
      '320': 0.14,
      '340': 0.2,
      '360': 0.25,
      '380': 0.46,
      '400': 0.57,
      '420': 0.67,
      '440': 0.77,
      '460': 0.84,
      '480': 0.9,
      '500': 0.94,
      '520': 0.96,
      '540': 0.97,
      '560': 0.97,
      '580': 0.97,
      '600': 0.97,
      '620': 0.96,
      '640': 0.95,
      '660': 0.94,
      '680': 0.93,
      '700': 0.92,
      '720': 0.89,
      '740': 0.86,
      '760': 0.84,
      '780': 0.82,
      '800': 0.77,
      '820': 0.73,
      '840': 0.68,
      '860': 0.6,
      '880': 0.55,
      '900': 0.48,
      '920': 0.4,
      '940': 0.33,
      '960': 0.27,
      '980': 0.19,
      '1000': 0.14
    }
  },
  iKonL936: {
    active: true,
    label: 'ANDOR iKon-L 936',
    dc: 0.000059,
    ro: 2.9,
    pxSize: 13.5e-6,
    qe: {
      '0': 0.97, // peak QE
      '300': 0.1,
      '320': 0.13,
      '340': 0.19,
      '360': 0.24,
      '380': 0.45,
      '400': 0.58,
      '420': 0.65,
      '440': 0.75,
      '460': 0.83,
      '480': 0.9,
      '500': 0.95,
      '520': 0.96,
      '540': 0.97,
      '560': 0.97,
      '580': 0.97,
      '600': 0.96,
      '620': 0.96,
      '640': 0.95,
      '660': 0.94,
      '680': 0.93,
      '700': 0.91,
      '720': 0.9,
      '740': 0.87,
      '760': 0.84,
      '780': 0.8,
      '800': 0.76,
      '820': 0.74,
      '840': 0.67,
      '860': 0.6,
      '880': 0.53,
      '900': 0.47,
      '920': 0.41,
      '940': 0.33,
      '960': 0.25,
      '980': 0.18,
      '1000': 0.13
    }
  },
  sbigstxl6303e: {
    active: true,
    label: 'SBIG STXL-6303E',
    dc: 0.5,
    ro: 15,
    pxSize: 9e-6,
    qe: {
      '0': 0.68, // peak QE
      '300': 0.62,
      '320': 0.62,
      '340': 0.62,
      '360': 0.62,
      '380': 0.62,
      '400': 0.62,
      '420': 0.62,
      '440': 0.62,
      '460': 0.62,
      '480': 0.62,
      '500': 0.62,
      '520': 0.62,
      '540': 0.62,
      '560': 0.62,
      '580': 0.62,
      '600': 0.62,
      '620': 0.62,
      '640': 0.62,
      '660': 0.62,
      '680': 0.62,
      '700': 0.62,
      '720': 0.62,
      '740': 0.62,
      '760': 0.62,
      '780': 0.62,
      '800': 0.62,
      '820': 0.62,
      '840': 0.62,
      '860': 0.62,
      '880': 0.62,
      '900': 0.62,
      '920': 0.62,
      '940': 0.62,
      '960': 0.62,
      '980': 0.62,
      '1000': 0.62
    }
  },
  ProLinePL23042: {
    active: true,
    label: 'ProLine PL23042',
    dc: 0.2,
    ro: 13,
    pxSize: 15e-6,
    qe: {
      '0': 0.93, // peak QE
      '300': 0.08,
      '320': 0.12,
      '340': 0.15,
      '360': 0.25,
      '380': 0.4,
      '400': 0.53,
      '420': 0.63,
      '440': 0.73,
      '460': 0.82,
      '480': 0.88,
      '500': 0.91,
      '520': 0.92,
      '540': 0.93,
      '560': 0.93,
      '580': 0.93,
      '600': 0.93,
      '620': 0.92,
      '640': 0.91,
      '660': 0.91,
      '680': 0.9,
      '700': 0.88,
      '720': 0.85,
      '740': 0.81,
      '760': 0.78,
      '780': 0.74,
      '800': 0.7,
      '820': 0.66,
      '840': 0.6,
      '860': 0.55,
      '880': 0.48,
      '900': 0.41,
      '920': 0.31,
      '940': 0.22,
      '960': 0.19,
      '980': 0.16,
      '1000': 0.1
    }
  }
};

export const BANDS = {
  'B': {
    active: true,
    label: <>B (4450 &#8491;)</>,
    wavelength: 4450,
    bandwidth: 760,
    fluxJY: 4260,
    fluxPh: 1444.762247191,
    extinctCoeff: 0.4 // mag/airmass - need to check value
  },
  'V': {
    active: true,
    label: <>V (5510 &#8491;)</>,
    wavelength: 5510,
    bandwidth: 960,
    fluxJY: 3640,
    fluxPh: 997.0032667877,
    extinctCoeff: 0.2 // mag/airmass - need to check value
  },
  'R': {
    active: true,
    label: <>R (6580 &#8491;)</>,
    wavelength: 6580,
    bandwidth: 1030,
    fluxJY: 3080,
    fluxPh: 706.4340425532,
    extinctCoeff: 0.1 // mag/airmass - need to check value
  },
  'I': {
    active: true,
    label: <>I (8060 &#8491;)</>,
    wavelength: 8060,
    bandwidth: 2830,
    fluxJY: 2550,
    fluxPh: 477.476426799,
    extinctCoeff: 0.08 // mag/airmass - need to check value
  },
  'L': {
    active: true,
    label: <>L (35000 &#8491;)</>,
    wavelength: 35000,
    bandwidth: 2770,
    fluxJY: 280,
    fluxPh: 12.07364926,
    extinctCoeff: 0 // no data
  },
  'Ha': {
    active: true,
    label: <>H&alpha; (6563 &#8491;)</>,
    wavelength: 6563,
    bandwidth: 65,
    fluxJY: 3631,
    fluxPh: 834.9729635,
    extinctCoeff: 0 // no data
  },
  'Red-continuum': {
    active: true,
    label: <>Red-continuum (6452 &#8491;)</>,
    wavelength: 6452,
    bandwidth: 90,
    fluxJY: 3631,
    fluxPh: 849.3378115,
    extinctCoeff: 0 // no data
  },
  '[SII]': {
    active: true,
    label: <>[SII] (6716 &#8491;)</>,
    wavelength: 6718,
    bandwidth: 65,
    fluxJY: 3631,
    fluxPh: 815.708181,
    extinctCoeff: 0 // no data
  },
  'G': {
    active: true,
    label: <>G (4770 &#8491;)</>,
    wavelength: 4770,
    bandwidth: 1450,
    fluxJY: 3631,
    fluxPh: 1149.436059,
    extinctCoeff: 0 // no data
  },
  'R1': {
    active: true,
    label: <>R (6231 &#8491;)</>,
    wavelength: 6231,
    bandwidth: 1300,
    fluxJY: 3631,
    fluxPh: 879.924571,
    extinctCoeff: 0 // no data
  },
  'I1': {
    active: true,
    label: <>I (7625 &#8491;)</>,
    wavelength: 7625,
    bandwidth: 1500,
    fluxJY: 3631,
    fluxPh: 719.057049,
    extinctCoeff: 0
  },
  'ZS': {
    active: true,
    label: <>ZS (8930 &#8491;)</>,
    wavelength: 8930,
    bandwidth: 980,
    fluxJY: 3631,
    fluxPh: 613.976484,
    extinctCoeff: 0
  },
  'Y': {
    active: true,
    label: <>Y (10200 &#8491;)</>,
    wavelength: 10200,
    bandwidth: 1060,
    fluxJY: 3631,
    fluxPh: 537.530392,
    extinctCoeff: 0
  }
};
